<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :loading="loading"
      >
        <template slot="enrollment_mappings" slot-scope="enrollment_mappings">
          <div v-for="(enrollment, index) in enrollment_mappings"
               :key="index">
            <div class="font-weight-bold">{{enrollment.student.first_name}} {{enrollment.student.last_name}}</div>
            <div>({{enrollment.student_code}} | {{enrollment.school_class.name}}-{{enrollment.section.name}}-{{enrollment.roll_no}})</div>
          </div>
        </template>
        <template slot="raised_by" slot-scope="created_by">
          <span >{{ created_by.first_name }} {{ created_by.last_name }}</span>
        </template>
        <template slot="created_by" slot-scope="created_by">
          <span >{{ created_by.phone }}</span>
        </template>
<!--        <template slot="student" slot-scope="student">
          <div>
            <div>{{student}}</div>
            <div class="font-weight-bold">{{student.enrollment_mappings[0].student.id}} {{student.enrollment.student.last_name}}</div>
            <div>({{student.enrollment.student_code}} | {{student.enrollment.school_class.name}}-{{student.enrollment.section.name}}-{{student.enrollment.roll_no}})</div>
          </div>
        </template>-->
        <template slot="start_date" slot-scope="start_date">
          <span class="font-weight-bold">{{moment(start_date).format(dateFormat)}}</span>
        </template>
        <template slot="end_date" slot-scope="end_date">
          <span class="font-weight-bold">{{moment(end_date).format(dateFormat)}}</span>
        </template>
        <template slot="reason" slot-scope="reason">
            <span style="overflow: hidden;
                         text-overflow: ellipsis;
                         white-space: nowrap;
                         display: inline-block;
                         max-width: 200px; /* Adjust as needed */">{{reason}}</span>
        </template>
<!--        <template slot="teacher_remark" slot-scope="teacher_remark">
          <span>{{teacher_remark}}</span>
        </template>-->
        <template slot="status" slot-scope="status">
          <a-tag :color="status === 'Pending' ? 'purple' : status === 'Approved' ? 'green' : 'red'">{{status}}</a-tag>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Set current -->
            <a-dropdown :trigger="['click']">
              <a href="javascript:;" class="btn btn-sm btn-primary mr-2">
                <i class="btn-addon-icon fe fe-shuffle" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item v-for="status in statuses" :key="status.value" :disabled="record.status === status.value"
                 @click="handleStatusChange(status.value, record)"
                >
                  {{ status.name }}
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            <!-- Edit -->
            <a href="javascript:;" v-if="rolesetting.editable" class="btn btn-sm btn-light mr-2"
              @click="showEditModal(record)"
            >
              <i class="btn-addon-icon fe fe-edit" />
              <!-- <edit-session ref="editBoard" @edited="handleEdited"/> -->
            </a>
            <!-- Delete -->
            <a href="javascript:;" v-if="rolesetting.deletable" class="btn btn-sm btn-danger "
              @click="onDelete(record)"
            >
              <i class="btn-addon-icon fe fe-trash" />
            </a>
          </div>
        </template>
      </a-table>
    </div>
    <edit-session ref="editBoard" @edited="handleEdited"/>
  </div>
</template>
<script>
import moment from 'moment'
import EditSession from '@/components/session/Forms/Edit/index'
import { statuses } from '../data'

const columns = [
  {
    title: 'Req. No.',
    className: 'text-left text-gray-6',
    width: '70px',
    dataIndex: 'leave_request_no',
  },
  {
    title: 'Student',
    className: 'text-left text-gray-6',
    width: '200px',
    dataIndex: 'enrollment_mappings',
    scopedSlots: { customRender: 'enrollment_mappings' },
  },
  {
    title: 'Raised by',
    className: 'text-left text-gray-6',
    width: '120px',
    dataIndex: 'created_by',
    scopedSlots: { customRender: 'raised_by' },
  },
  {
    title: 'Phone',
    className: 'text-left text-gray-6',
    width: '90px',
    dataIndex: 'created_by',
    scopedSlots: { customRender: 'created_by' },
  },
  /* {
    title: 'Student',
    className: 'text-left text-gray-6',
    width: '200px',
    scopedSlots: { customRender: 'student' },
  }, */
  {
    title: 'Start Date',
    width: '90px',
    dataIndex: 'start_date',
    key: 'start_date',
    scopedSlots: { customRender: 'start_date' },
  },
  {
    title: 'End Date',
    width: '90px',
    dataIndex: 'end_date',
    key: 'end_date',
    scopedSlots: { customRender: 'end_date' },
  },
  {
    title: 'Duration',
    width: '100px',
    dataIndex: 'duration',
    key: 'duration',
    scopedSlots: { customRender: 'duration' },
  },
  {
    title: 'Reason',
    width: '200px',
    dataIndex: 'reason',
    key: 'reason',
    scopedSlots: { customRender: 'reason' },
  },
  /* {
    title: 'Teacher remark',
    dataIndex: 'teacher_remark',
    scopedSlots: { customRender: 'teacher_remark' },
  }, */
  {
    title: 'Status',
    width: '50px',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {

  name: 'LeaveRequestTable',
  components: {
    EditSession,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
    rolesetting: { type: Object },
  },
  data: function() {
    return {
      statuses,
      columns,
      selectedRowKeys: [],
      dateFormat: 'DD-MM-YYYY',
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    moment,
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showEditModal: function(record) {
      this.$eventBus.$emit('openStudentLeaveRequestFormModal', record.id)
    },
    handleEdited: function () {
      this.$emit('updateTable')
    },
    handleStatusChange: function(status, record) {
      this.$confirm({
        title: 'Are you sure?',
        content: `Change status to ${status}.`,
        okText: 'Yes',
        okType: 'primary',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .get('/api/student/leave_request/' + record.id + '/toggle-status', {
              params: {
                status,
              },
            })
            .then(({ data }) => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Leave request status changed Successfully!',
                description: `Status changed to ${status}`,
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },

    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure?',
        content: 'Click Yes to delete the Leave Request.',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/student/leave_request/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: 'Leave request has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
